import { useQuery } from "@tanstack/react-query";
import { AiJobDto, AuditEntryDto, ListResponse } from "@reina/shared";
import { api } from "./client";

/** Ops hooks: audit feed + AI job ledger (contract §Ops). */

const AuditList = ListResponse(AuditEntryDto);
const AiJobList = ListResponse(AiJobDto);

export type AuditParams = {
  entityType?: string;
  entityId?: string;
  actorId?: string;
  limit?: number;
  offset?: number;
};

/** Audit feed — server returns newest first. */
export function useAudit(params: AuditParams = { limit: 50 }) {
  return useQuery({
    queryKey: ["audit", "list", params],
    queryFn: () => api.get("/audit", { query: params, schema: AuditList }),
  });
}

export type AiJobParams = {
  kind?: string;
  limit?: number;
  offset?: number;
};

export function useAiJobs(params: AiJobParams = { limit: 500 }) {
  return useQuery({
    queryKey: ["ai-jobs", "list", params],
    queryFn: () => api.get("/ai-jobs", { query: params, schema: AiJobList }),
  });
}
